// extracted by mini-css-extract-plugin
export var errorsContainer = "_t9-1";
export var link = "_t9-0";